import { Weblog } from "@ks/weblogger/lib/log.browser";
import Radar from "@ks-radar/radar";
const PRODUCT_NAME = "duanju";
export const radar = new Radar({
    projectId: "b3803e9d73",
    sampling: 1,
    customDimensions: {
        release_tag: window.kfxEnv?.channelId,
        product_version: window.kfxEnv?.version,
    },
    ignoreAborted: true,
    APIHook(apiData) {
        try {
            const { response } = apiData;

            if (response.status !== 200) {
                throw Error("not 200");
            }

            const isJSON = response.headers?.["content-type"]?.toLowerCase().includes("application/json");

            if (!isJSON) {
                throw Error("not json");
            }

            const data = JSON.parse(response.data);

            return {
                response_code: data.result,
                response_msg: String(data.message || ""),
                custom_failed: data.result !== 1,
                intercept_report: false,
            };
        } catch (e: unknown) {
            return {
                response_code: -9999,
                response_msg: String((e as Error).message || ""),
                custom_failed: false,
                intercept_report: false,
            };
        }
    },
});

const isProd = location.href.includes("duanju.kuaishou.com");

export const weblogger = new Weblog(
    {
        env: !isProd ? "logger" : "production",
        plugins: [
            // @ts-expect-error
            radar
        ],
    },
    {
        product_name: PRODUCT_NAME,
    }
);
